var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "spinner" } }, [
    _c("div", { staticClass: "waiting" }, [
      _c("div", { staticClass: "spinner-ctn" }, [
        _c("div", { staticClass: "dot dot1" }),
        _c("div", { staticClass: "dot dot2" }),
        _c("div", { staticClass: "dot dot3" })
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }